/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _version = require('../../helper/version');

var _version2 = _interopRequireDefault(_version);

var _im = require('../../libs/im');

var _actErrcode = require('../../helper/actErrcode');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// this is api of mudu live page
// var browser = require('../../helper/browser');
var config = require('../config');
var tracker = require('../modules/Tracker');
var md5 = require('md5');
// 观看地址定制0:关闭 1:仅内网 2仅海外 3根据ip切换
var CustomizedAddressType = {
    INTRANET_ONLY: 1,
    OVERSEA_ONLY: 2,
    AUTO_SWITCH_BY_IP: 3,
    NULL: 0
};

var versionTag = '#MDLSDK' + _version2["default"];

module.exports = function () {
    function Room(param) {
        (0, _classCallCheck3["default"])(this, Room);

        _scope.Feature.EventBus(this);
        _scope.Feature.User(this);
        _scope.Feature.Comment(this);
        _scope.Feature.LuckyDraw(this);
        _scope.Feature.PPT(this);
        _scope.Feature.Barrage(this);
        _scope.Feature.Vote(this);
        _scope.Feature.Signup(this);
        _scope.Feature.Topic(this);
        _scope.Feature.Redpack(this);
        _scope.Feature.Reward(this);
        _scope.Feature.Signin(this);
        _scope.Feature.Appointment(this);
        _scope.Feature.Notice(this);
        this.act_id = param.roomId;
        this.actHashId = param.roomHashId;

        this.tracker = tracker(function () {
            _scope.MsgBus.Pub('Tracker.Init.Over');
        });
        _scope.DB.Set('Room', this);
        this._msgbusDestroy();
        _scope.MsgBus.OnMultiOnce(['Room.StreamUpdate.Over', 'Room.TrailerUpdate.Over'], function () {
            _scope.MsgBus.Pub('Room.Init.Over');
        });

        this.mapStreamToPlaylistItem = {}; // 流id到直播playlistItem的映射对象
        this.mapStreamToTrailerItems = {}; // 流id到回放视频（单个）的映射
        this.mainStream = ''; // 主流id
        this.allStreams = []; // 所有流数据列表（流id、名称、推流状态）

        // 兼容老数据
        this.originMainStream = {}; // 原始流数据，默认记录主流
    }

    (0, _createClass3["default"])(Room, [{
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this = this;

            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
                _scope.MsgBus.UnSubAll('User.WatchTime');

                _this.allStreams.forEach(function (stream) {
                    rop.Remove('stream-event-' + stream);
                });
                _scope.MsgBus.UnSubAll('Room.StreamEvent');
                _scope.MsgBus.UnSubAll('Room.ViewNumChanged');

                _scope.MsgBus.UnSubAll('Room.Init.Error');
                _scope.MsgBus.UnSubAll('SendObj.PPT');
                _scope.MsgBus.UnSubAll('SendObj.Signup');
                _scope.MsgBus.UnSubAll('SendObj.Signin');
                _scope.MsgBus.UnSubAll('SendObj.Topic');
                _scope.MsgBus.UnSubAll('SendObj.Reward');
                _scope.MsgBus.UnSubAll('SendObj.Comment');
                _scope.MsgBus.UnSubAll('Room.Init.Over');
                _scope.MsgBus.UnSubAll('Room.StreamUpdate.Over');
                _scope.MsgBus.UnSubAll('Room.TrailerUpdate.Over');
                _scope.MsgBus.UnSubAll('User.Offline');

                _this._destroy();

                _scope.MsgBus.UnSub(_this.destroyKey);
            });
        }
    }, {
        key: '_startSeesion',
        value: function _startSeesion(actHashId, projectId) {
            var _this2 = this;

            var data = {
                project_id: projectId,
                //referer: (document.referrer || '').split('/').slice(0, 3).join('/'), // 仅保留协议 域名 端口,
                screen_resolution: (window.screen.width || 0) + 'x' + (window.screen.height || 0),
                language: (navigator.language || '').toLowerCase().substr(0, 2),
                from_label: this.tracker.getOrigintype(),
                from_value: '',
                location: window.location.href + versionTag,
                service_provider: '',
                title: this.name,
                page: this.tracker.getPage()
            };
            Fetcher.Post(config.USER_AUTH_START_SESSION + '?act_id=' + actHashId, (0, _stringify2["default"])(data), function (res, code) {

                if (code === 403) {
                    _this2._login_by_anonymous(actHashId);
                } else {
                    res = JSON.parse(res);
                    var newUser = {
                        session_id: res.session_id,
                        token: res.token,
                        user: res.user
                    };
                    _this2._updateUserAuth(newUser);
                    _this2._updateUserPhone(newUser);
                }
            }, (0, _extends3["default"])({
                'Content-Type': 'application/json'
            }, this._tokenHeader));
        }
        // 更新用户身份信息，token、session

    }, {
        key: '_updateUserAuth',
        value: function _updateUserAuth(authInfo) {
            if (authInfo.token) {
                this._tokenHeader = {
                    authorization: 'Bearer ' + authInfo.token
                };
            }
            if (authInfo.session_id) {
                this._sessionHeader = {
                    MUDUTVSESSIONID: authInfo.session_id
                };
            }
            _scope.DB.Set('requestHeader', { session: this._sessionHeader, token: this._tokenHeader });
        }
        // session start之后获取当前用户绑定的手机号

    }, {
        key: '_updateUserPhone',
        value: function _updateUserPhone(newUser) {
            // 只有assign的用户才会有手机号
            var updatePhoneParam = {
                act_id: this.actHashId,
                event: 'assign',
                session_id: newUser.session_id
            };
            Fetcher.Post(config.API_DOMAIN + '/user/api/should_update_useract_phone', (0, _stringify2["default"])(updatePhoneParam), function (res) {
                var phone = '';
                try {
                    var data = JSON.parse(res);
                    if (data.errcode === 1000) {
                        phone = data.phone;
                    }
                } catch (error) {
                    console.error(error);
                }
                _scope.MsgBus.Pub('User.StartSeesionSuccess', (0, _extends3["default"])({}, newUser, { user: (0, _extends3["default"])({}, newUser.user, { phone: phone }) }));
            }, (0, _extends3["default"])({
                'Content-Type': 'application/json'
            }, this._tokenHeader));
        }
    }, {
        key: '_login_by_anonymous',
        value: function _login_by_anonymous(actHashId) {
            var _this3 = this;

            // 请求匿名身份
            var data = (0, _stringify2["default"])({
                nick: _scope.Utils.GetCookie('user') || '',
                avatar: _scope.Utils.GetCookie('avatar') || '',
                session_data: {
                    screen_resolution: (window.screen.width || 0) + 'x' + (window.screen.height || 0),
                    language: (navigator.language || '').toLowerCase().substr(0, 2),
                    from_label: this.tracker.getOrigintype(),
                    from_value: '',
                    title: this.name,
                    page: this.tracker.getPage()
                }
            });
            Fetcher.Post(config.USER_AUTH_ANONYMOUS + '?act_id=' + actHashId, data, function (res) {
                res = JSON.parse(res);
                var userObj = {
                    session_id: res.session_id,
                    token: res.token,
                    user: res.user
                };
                _this3._updateUserAuth(userObj);
                _this3._updateUserPhone(userObj);
            }, {
                'Content-Type': 'application/json'
            });
        }
    }, {
        key: '_subEvent',
        value: function _subEvent() {
            var _this4 = this;

            var self = this;

            function pickPptUrl(position, urls) {
                for (var i = 0; i < urls.length; i++) {
                    var item = urls[i];
                    var nextItem = urls[i + 1];
                    if (item.position <= position && (!nextItem || nextItem.position > position)) {
                        return item.url;
                    }
                }
                return '';
            }

            //监听事件
            _scope.MsgBus.Sub('User.Offline', function () {
                if (_this4.restartingSession) {
                    return;
                }
                // 用户心跳掉线，重新session/start
                _this4._startSeesion(_this4.actHashId, _this4.projectId);
                _this4.restartingSession = true;
            });
            _scope.MsgBus.Sub('User.WatchTime', function (data) {
                _this4.WatchTime(data);
            });
            _scope.MsgBus.Sub('Player.pptTimer', function (data) {
                if (!self.trailer || !self.trailer.m3u8) {
                    return;
                }
                var playSourceList = data.getPlayFile();
                if (playSourceList.filter(function (v) {
                    return v.file.replace('s://', '://') === self.trailer.m3u8.replace('s://', '://');
                })[0]) {
                    var position = data.getPosition();
                    var url = pickPptUrl(position, self.trailer.ppt_list);
                    if (url && url !== self.trailer.currentUrl) {
                        self.trailer.currentUrl = url;
                        _scope.MsgBus.Pub('PPT.trailer.changed', {
                            currentUrl: url,
                            open: self.trailer.open,
                            player: data.player,
                            position: position
                        });
                    }
                }
            });
            _scope.MsgBus.Sub('Room.TrailerUpdate.Over', function () {
                var currentStream = _this4.mainStream;
                // 没有主流标记，且当前频道只有一个流画面，那么就用当前流
                if (!_this4.mainStream && (0, _keys2["default"])(_this4.mapStreamToTrailerItems).length === 1) {
                    currentStream = (0, _keys2["default"])(_this4.mapStreamToTrailerItems)[0];
                }
                if (!currentStream) {
                    return;
                }
                _this4._getTrailerPPtList(_this4.mapStreamToTrailerItems[currentStream].video_id);
            });

            // rop消息转发
            // (function (self) {
            //     rop.On('stream-event-' + self.stream, function (data) {
            //         var obj = JSON.parse(data);
            //         if (obj.stream != self.stream) {
            //             return;
            //         }
            //         self.live_status = obj.event;
            //         _scope.MsgBus.Pub('Room.StreamEvent', data);
            //     });

            // })(this);
        }
    }, {
        key: 'Init',
        value: function Init() {
            // this._setSocialUser();
            this.platform = function () {
                var userAgentInfo = navigator.userAgent;
                var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
                var flag = 'pc';
                for (var v = 0; v < Agents.length; v++) {
                    if (userAgentInfo.indexOf(Agents[v]) > 0) {
                        flag = 'mobile';
                        break;
                    }
                }
                return flag;
            }();

            this.InitData();
        }
    }, {
        key: 'WatchTime',
        value: function WatchTime(param) {
            var time = param.duration || 0;
            var activeFile = '';

            // 获取当前播放器信息
            // 判断 当前是直播流 且 已经断流的情况为invalid
            try {
                if ('function' === typeof param.getPlayer) {
                    var player = param.getPlayer();
                    if (player && 'function' === typeof player.getPlaylist) {
                        var list = player.getPlaylist();
                        if (list && list instanceof Array) {
                            var activeItem = list.filter(function (v) {
                                return v.active;
                            })[0];
                            if (activeItem) {
                                activeFile = (activeItem.sources || []).filter(function (v) {
                                    return v.active;
                                })[0].file || '';
                                var isInLiveAddress = [].concat((0, _toConsumableArray3["default"])(this.internal), (0, _toConsumableArray3["default"])(this.intranet), (0, _toConsumableArray3["default"])(this.oversea)).map(function (v) {
                                    return v.address;
                                }).indexOf(activeFile) !== -1;

                                if (this.live_status === 0 && activeFile && isInLiveAddress) {
                                    return;
                                }
                            }
                        }
                    }
                }
            } catch (e) {} /** */

            // 防止修改系统时间等方式造成的数据异常
            if (time < 0) {
                time = 0;
            } else if (time > 70) {
                time = 70;
            }

            // tracker
            if (this.tracker && 'function' === typeof this.tracker.triggerEvent) {
                this.tracker.triggerEvent({
                    category: 'video',
                    action: this.live_status ? 'live_watch_time' : 'vod_watch_time',
                    value: time || 0,
                    label: activeFile
                });
            }
        }
    }, {
        key: 'InitData',
        value: function InitData() {
            var _this5 = this;

            var idParam = this.actHashId ? '&act_hash_id=' + this.actHashId : '&id=' + this.act_id;
            var url = config.BASE_INFO_URL + idParam + '&url=' + encodeURIComponent(location.href.replace(location.hash, ''));
            try {
                Fetcher.Get(url, function (data, code) {
                    if (code != 200) {
                        _scope.MsgBus.Pub('Room.Init.Over');
                        _scope.MsgBus.Pub('Room.Init.Error', code);
                    } else {

                        var jsonObj = JSON.parse(data);
                        var arrearsStatus = jsonObj.status || ''; // 频道的errCode
                        var actErrorType = (0, _actErrcode.parseActErrorCode)(arrearsStatus, jsonObj.delayType);

                        // 用户欠费状态
                        _scope.DB.Set('User.Arrears.Status', {
                            code: arrearsStatus,
                            hasLiveErrcode: actErrorType.hasLiveErrcode,
                            hasTrailerErrcode: actErrorType.hasTrailerErrcode
                        });
                        _this5.act_id = jsonObj.act.id;
                        _this5.server_timestamp = jsonObj.timestamp;
                        _this5.name = jsonObj.act.name;
                        _this5.stream = jsonObj.act.stream;
                        _this5.fee_status = jsonObj.act.fee_status;
                        _this5.limit_status = jsonObj.act.limit_status;
                        _this5.live_status = jsonObj.act.live_status;
                        _this5.share_url = jsonObj.shareUrl;
                        _this5.view_num = jsonObj.viewNum; // 按照倍率配置计算之后的人数
                        _this5.lastUpdateViewNumAt = Date.now(); // 最后一次更新人数的时间
                        _this5.view_num_basic = jsonObj.act.view_num_basic; // 基础人数
                        _this5.view_num_multiple = jsonObj.act.view_num_multiple; // 倍数
                        _this5.view_num_type = jsonObj.act.view_num_type; // 0关闭 1累计 2实时
                        if (_this5.view_num_type > 0) {
                            setTimeout(function () {
                                _this5.RefreshViewNum();
                            }, 60 * 1000);
                        }
                        _this5.total_view_num = jsonObj.act.analysis.total_visit_num;
                        _this5.rtmp_play_addr = jsonObj.rtmp_play_addr;
                        _this5.isoversea = jsonObj.internal === 0;
                        _this5.privacy_policy = jsonObj.privacy_policy; // 隐私政策
                        // console.log('baseInfo', jsonObj);
                        _this5.has_multi_stream_line = false; // 是否有多个线路或分辨率可提供切换
                        _this5.isListLiving = false; // 是否频道在使用列表直播
                        _this5.listLiveAddress = ''; // 列表直播拉流地址

                        // this.trailer = Object.assign(jsonObj.trailer[0] || {m3u8: '', open: 0, trailer_img: ''}, {ppt_list: [], currentUrl: ''});
                        _this5.trailer = (0, _assign2["default"])(jsonObj.trailer[0] || { draggable: true, triple_speed: true, open: false }, { ppt_list: [], currentUrl: '' });
                        _this5.trailerList = {};

                        _this5.live_img = jsonObj.live_img || jsonObj.console_setting_image || 'https://static.mudu.tv/assets/livecoverimg.jpg';
                        _this5.banners = jsonObj.act.banners || [];
                        _this5.theme = jsonObj.act.theme || 'default';
                        _this5.themes = jsonObj.act.themes || [];
                        _this5.uin = jsonObj.act.uin;
                        // 版本定制内容: 强行使用回放打点，2022.7.25下线
                        _this5.isCustomForceHighlight = config.customForceBookmarkUin.indexOf(_this5.uin) !== -1;
                        _this5.countdown = jsonObj.countdown;
                        _this5.actHashId = jsonObj.actHashId;
                        _this5.domain = jsonObj.domain ? 'http://' + jsonObj.domain : 'http://mudu.tv';
                        _this5.projectId = jsonObj.projectId;

                        if (Object.prototype.toString.call(jsonObj.dingdingIsvConfig) === '[object Object]') {
                            _this5.dingdingIsvConfig = jsonObj.dingdingIsvConfig;
                        }

                        _scope.DB.Set('socialAuthConfig', {
                            isSetType: {
                                issetQq: jsonObj.issetQq,
                                issetWeibo: jsonObj.issetWeibo,
                                issetWeixin: jsonObj.issetWeixin
                            },
                            oauth2AppIdConfig: jsonObj.oauth2AppIdConfig
                        });
                        // baseinfo 完成调用startsession
                        _this5.tracker.setPage(jsonObj.actHashId);
                        _scope.MsgBus.Sub('User.AssignLoginByOther', function (data) {
                            _this5._updateUserAuth({ token: data.token });
                            _this5._startSeesion(jsonObj.actHashId, jsonObj.projectId);
                        });
                        _this5._startSeesion(jsonObj.actHashId, jsonObj.projectId);
                        _scope.MsgBus.Sub('User.StartSeesionSuccess', function (userInfo) {
                            _this5.restartingSession = false;
                            // 监听到StartSeesionSuccess成功以后再去获取其他信息
                            _this5._fetchMenus();
                            _this5._setThemeImgUrlAbsolute();
                            _this5._setLiveImgAbsolute();
                            _this5._subEvent();
                            _this5._getVideoTrailerInfo();
                            _this5._updateListLiveConfig(!!jsonObj.act.list_live_status);
                            // 初始化im连接(只初始化，不连接)
                            (0, _im.createIMClient)({ userToken: userInfo.token, actHashId: _this5.actHashId });
                            // start session 之后更新流水 property
                            _this5.tracker.updateProperties({
                                name: userInfo.user.nick,
                                third_id: userInfo.user.assign_id,
                                avatar: userInfo.user.avatar,
                                outer_id: userInfo.user.outer_id
                            });

                            // 文档
                            // 如果已经初始化过，unsub topic之后重新初始化
                            if (_this5.PPT) {
                                _this5.PPT.UnSubPPTTopics();
                            }
                            _scope.MsgBus.Pub('SendObj.PPT', new _scope.PPT({
                                act_id: jsonObj.act.id,
                                config: jsonObj.act.slides,
                                actHashId: jsonObj.actHashId,
                                tracker: _this5.tracker
                            }));
                            // 投票
                            if (_this5.Vote) {
                                _this5.Vote.UnSubVoteTopics();
                            }
                            _scope.MsgBus.Pub('SendObj.Vote', new _scope.Vote({
                                act_id: jsonObj.act.id,
                                vote: jsonObj.vote,
                                tracker: _this5.tracker
                            }));
                            // 问卷
                            if (_this5.Signup) {
                                _this5.Signup.UnSubSignTopics();
                            }
                            _scope.MsgBus.Pub('SendObj.Signup', new _scope.Signup({
                                tracker: _this5.tracker,
                                actHashId: jsonObj.actHashId,
                                privacyUrl: _this5.privacy_policy
                            }));
                            // 签到
                            if (_this5.Signin) {
                                _this5.Signin.UnSubSigninTopic();
                            }
                            _scope.MsgBus.Pub('SendObj.Signin', new _scope.Signin({
                                actHashId: jsonObj.actHashId
                            }));
                            // 话题互动
                            if (_this5.Topic) {
                                _this5.Topic.UnSubTopics();
                            }
                            _scope.MsgBus.Pub('SendObj.Topic', new _scope.Topic({
                                act_id: jsonObj.act.id,
                                topic_visitor_publish: jsonObj.act.topic_visitor_publish,
                                topic_needs_check: jsonObj.act.topic_needs_check,
                                topic_allow_reply: jsonObj.act.topic_allow_reply,
                                topic_count_num: jsonObj.topicNum,
                                tracker: _this5.tracker
                            }));
                            // 预约
                            _scope.MsgBus.Pub('SendObj.Appointment', new _scope.Appointment(jsonObj.actHashId));
                            // 公告
                            _scope.MsgBus.Pub('SendObj.Notice', new _scope.Notice(jsonObj.actHashId));
                            // 打赏
                            if (_this5.Reward) {
                                _this5.Reward.UnSubRewardTopics();
                            }
                            _scope.MsgBus.Pub('SendObj.Reward', new _scope.Reward({ jsonObj: jsonObj, Room: _this5 }));
                            // 聊天
                            if (_this5.Comment) {
                                _this5.Comment.UnSubCommentsTopic();
                            }
                            _scope.MsgBus.Pub('SendObj.Comment', new _scope.Comment({ jsonObj: jsonObj, Room: _this5 }));
                            _this5._getStreamAddress();
                        });
                    }
                });
            } catch (err) {
                _scope.MsgBus.Pub('Room.Init.Over');
                _scope.MsgBus.Pub('Room.Init.Error', err);
            }
        }

        // 内：更新列表直播配置

    }, {
        key: '_updateListLiveConfig',
        value: function _updateListLiveConfig(isLiving) {
            var _this6 = this;

            this.isListLiving = isLiving;
            this.listLiveAddress = '';

            // 开启状态就更新一下列表直播拉流地址
            if (this.isListLiving) {
                Fetcher.Get(config.API_DOMAIN + '/activity/v1/watch/' + this.actHashId + '/list_live/addr', function (resp) {
                    var res = JSON.parse(resp);
                    if (res.errcode === 1000) {
                        _this6.listLiveAddress = res.data.address;
                    }

                    _scope.DB.Set('listLiveConfig', {
                        isLiving: _this6.isListLiving,
                        address: _this6.listLiveAddress
                    });
                    _scope.MsgBus.Pub('Room.ListLiveConfig', {
                        inUse: _this6.isListLiving,
                        address: _this6.listLiveAddress
                    });
                }, this._tokenHeader);
            } else {
                _scope.DB.Set('listLiveConfig', {
                    isLiving: this.isListLiving,
                    address: this.listLiveAddress
                });
                _scope.MsgBus.Pub('Room.ListLiveConfig', {
                    inUse: this.isListLiving,
                    address: this.listLiveAddress
                });
            }
        }
    }, {
        key: '_setThemeImgUrlAbsolute',
        value: function _setThemeImgUrlAbsolute() {
            this.themes = this.themes.map(function (v) {
                v.banner = _scope.Utils.GetAbsoluteUrl({ url: v.banner, domain: 'mudu.tv' });
                v.cover_img = _scope.Utils.GetAbsoluteUrl({ url: v.cover_img, domain: 'mudu.tv' });
                return v;
            });
        }
    }, {
        key: '_setLiveImgAbsolute',
        value: function _setLiveImgAbsolute() {
            this.live_img = _scope.Utils.GetAbsoluteUrl({ url: this.live_img, domain: 'mudu.tv' });
        }
    }, {
        key: '_destroy',
        value: function _destroy() {
            clearTimeout(this._refreshViewNumTimer);
            clearInterval(this._userOnlineTimer);
            this.tracker.destroy();
        }
    }, {
        key: '_getVideoTrailerInfo',
        value: function _getVideoTrailerInfo() {
            var _this7 = this;

            var _self = this;
            if (!this.actHashId) return;
            var nowTimeStamp = Date.parse(new Date().toString()) / 1000;

            Fetcher.Get(config.API_DOMAIN + '/videos/view/act/' + this.actHashId + '/playback?timestamp=' + nowTimeStamp, function (data) {
                var res = JSON.parse(data);
                if (res.errcode !== 1000) {
                    (0, _assign2["default"])(_self.trailer, {
                        draggable: true,
                        stream_name: '',
                        triple_speed: true,
                        video_from: 1,
                        videos: [],
                        ppt_list: []
                    });
                    return;
                }
                var playbackList = res.data.playback_list;
                // 处理多流回放
                var allTrailerList = playbackList.map(function (playback) {
                    // 当且仅当设置为单个视频回放，且回放视频存在（自动回放可能存在视频还未生成的情况）时，设置open=true
                    var isOpen = playback.video_from === 1 && Array.isArray(playback.videos) && playback.videos.length;
                    var trailerItem = {
                        triple_speed: playback.triple_speed,
                        draggable: playback.draggable,
                        stream_id: playback.stream_name,
                        open: isOpen,
                        video_id: isOpen ? playback.videos[0].video_id : '',
                        trailer_img: isOpen ? playback.videos[0].video_thumb : '',
                        resolution: isOpen ? playback.videos[0].resolution : '',
                        ppt_list: [],
                        bookmarks: [],
                        m3u8: ''
                    };
                    _this7.mapStreamToTrailerItems[playback.stream_name] = trailerItem;
                    return trailerItem;
                });

                // 使用第一路回放数据：当单流频道，直接设置默认值
                _this7.trailer = allTrailerList[0];

                // 有设置回放的直播画面获取回放视频
                var allOpenedTrailerStream = (0, _keys2["default"])(_this7.mapStreamToTrailerItems).filter(function (stream) {
                    return _this7.mapStreamToTrailerItems[stream].open;
                });
                if (allOpenedTrailerStream.length) {
                    _promise2["default"].all(allOpenedTrailerStream.map(function (stream) {
                        var trailerInfo = _this7.mapStreamToTrailerItems[stream];
                        return _this7._getVideoInfo(trailerInfo.video_id, trailerInfo.resolution);
                    })).then(function (resArr) {
                        for (var index in resArr) {
                            _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]].m3u8 = resArr[index].url || '';
                            _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]].bookmarks = resArr[index].bookmarks;
                            // 更新默认线路回放
                            if (_this7.trailer.stream_id === _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]].stream_id) {
                                _this7.trailer = _this7.mapStreamToTrailerItems[allOpenedTrailerStream[index]];
                            }
                        }
                        // 定制逻辑，强制使用回放视频的打点信息
                        if (_this7.isCustomForceHighlight) {
                            _scope.DB.Set('CUSTOM_FORCE_HIGHLIGHT', _this7.trailer.bookmarks || []);
                        }

                        _scope.DB.Set('trailerInfo', _this7.trailer); // 将回看信息保存在DB中

                        _scope.MsgBus.Pub('Room.TrailerUpdate.Over');
                    })["catch"](function () {
                        _this7.trailer.open = false;
                        _scope.MsgBus.Pub('Room.TrailerUpdate.Over');
                    });
                    return;
                }

                _scope.MsgBus.Pub('Room.TrailerUpdate.Over');
            }, (0, _extends3["default"])({}, this._tokenHeader, {
                sign: md5(this._tokenHeader.authorization.split(' ')[1] + nowTimeStamp)
            }));
        }
    }, {
        key: '_getVideoInfo',
        value: function _getVideoInfo(video_id, resolution) {
            var _this8 = this;

            return new _promise2["default"](function (resolve, reject) {
                if (!video_id) {
                    return;
                }
                var nowTimeStamp = Date.parse(new Date().toString()) / 1000;
                return Fetcher.Get(config.API_DOMAIN + '/videos/view/act/' + _this8.actHashId + '/video?video_id=' + video_id + '&timestamp=' + nowTimeStamp + '&resolution=' + (resolution || ''), function (data) {
                    var res = JSON.parse(data);
                    if (res.errcode === 1000) {
                        // return res.data;
                        resolve(res.data);
                    } else {
                        reject('error');
                    }
                }, (0, _extends3["default"])({
                    sign: md5(_this8._tokenHeader.authorization.split(' ')[1] + nowTimeStamp)
                }, _this8._tokenHeader));
            });
        }
    }, {
        key: '_getTrailerPPtList',
        value: function _getTrailerPPtList(video_id) {
            var self = this;
            if (!video_id) return;

            Fetcher.Get(config.API_DOMAIN + '/?c=activity&a=ajaxgetvideoslides&video_id=' + video_id, function (data) {
                var res = JSON.parse(data);
                if (res.status === 'n') {
                    return;
                }
                if (res.status === 'y') {
                    self.trailer.ppt_list = res.data || [];
                }
            }, this._tokenHeader);
        }

        /**
         * 内部：解析直播流地址
         */

    }, {
        key: '_getStreamAddress',
        value: function _getStreamAddress() {
            var _this9 = this;

            var url = config.API_DOMAIN + '/activity/v2/' + this.actHashId + '/videos';

            Fetcher.Get(url, function (data, code) {
                try {
                    data = JSON.parse(data);
                    if (code !== 200) {
                        throw new Error(code);
                    }

                    if (data.errcode !== 1000) {
                        throw new Error(data.errcode);
                    }
                    var streamViews = data.data || []; //所有流


                    _this9.allStreams = streamViews.map(function (stream) {
                        var playlistItem = _this9._formatPlaylistItem(stream);
                        _this9.mapStreamToPlaylistItem[stream.stream] = playlistItem;
                        return {
                            stream_id: stream.stream,
                            name: stream.name,
                            live_status: !!stream.live_status,
                            is_main: !!stream.is_main
                        };
                    });

                    // const currentStreamView = streamViews.filter(v => v.is_main === 1)[0]; // 主流


                    _scope.DB.Set('liveAddrList', [_this9.mapStreamToPlaylistItem[_this9.mainStream]]); // 将流地址保存在DB中
                    _scope.DB.Set('mainStream', _this9.mainStream);
                    _scope.DB.Set('mapStreamToPlaylistItem', _this9.mapStreamToPlaylistItem);

                    _scope.MsgBus.Pub('Room.StreamUpdate.Over');

                    _this9._subAllStreamStatus();
                    _this9._subListLiveStatus();
                } catch (err) {
                    _scope.MsgBus.Pub('Room.Init.Over');
                    _scope.MsgBus.Pub('Room.Init.Error', err);
                }
            }, this._tokenHeader);
        }

        // 监听每一条线路的live status变更

    }, {
        key: '_subAllStreamStatus',
        value: function _subAllStreamStatus() {
            var _this10 = this;

            this.allStreams.forEach(function (stream, index) {
                rop.On('stream-event-' + stream.stream_id, function (data) {
                    var obj = JSON.parse(data);
                    // 主流状态更新到频道直播状态
                    if (obj.stream === _this10.mainStream) {
                        _this10.live_status = obj.event;
                    }
                    // 更新此路流的状态
                    _this10.allStreams[index].live_status = !!obj.event;
                    _scope.MsgBus.Pub('Room.StreamEvent', data);
                });
            });
        }

        // 监听列表直播开关状态

    }, {
        key: '_subListLiveStatus',
        value: function _subListLiveStatus() {
            var _this11 = this;

            // 列表直播开启同时会收到stream-event消息，不需要额外提醒用户开始直播
            rop.On('list-live-' + this.actHashId, function (msg) {
                try {
                    var data = JSON.parse(msg);
                    _this11._updateListLiveConfig(!!data.status);
                } catch (error) {
                    console.error(error);
                }
            });
        }

        // 转成播放器要的playlist格式

    }, {
        key: '_formatPlaylistItem',
        value: function _formatPlaylistItem(streamItem) {
            var liveItem = {};
            switch (streamItem.customized_address) {
                case CustomizedAddressType.INTRANET_ONLY:
                    // 仅内网，用内网地址
                    liveItem = streamItem.intranet;
                    break;
                case CustomizedAddressType.OVERSEA_ONLY:
                    // 仅海外，用海外地址
                    liveItem = streamItem.oversea;
                    break;
                case CustomizedAddressType.AUTO_SWITCH_BY_IP:
                    // 根据IP切换，内网地址有用内网，否则海外地址有用海外
                    if (streamItem.intranet.sign_list.length > 0) {
                        liveItem = streamItem.intranet;
                    } else if (!!this.isoversea && streamItem.oversea.sign_list.length > 0) {
                        liveItem = streamItem.oversea;
                    } else {
                        liveItem = streamItem.internal;
                    }
                    break;
                case CustomizedAddressType.NULL: // 仅公网（默认）
                default:
                    liveItem = streamItem.internal;
            }

            var sources = [];
            var firstUsefulPlayAddr = ''; // 记录第一路可用线路（非空）
            liveItem.sign_list.forEach(function (signList, signIndex) {
                signList.resolutions.forEach(function (v, idx) {
                    var path = signList.line_name || '';
                    var label = v.resolution || '';
                    switch (v.resolution) {
                        case 'origin':
                            label = '原画';
                            break;
                        case 'fhd':
                            label = '1080P';
                            break;
                        case 'hd':
                            label = '720P';
                            break;
                        case 'sd':
                            label = '480P';
                            break;
                        default:
                    }
                    sources.push({
                        file: v.pull_address,
                        label: label,
                        path: path,
                        path_name: path,
                        defaultPlay: signIndex === 0 && idx === 0
                    });
                    if (v.pull_address && !firstUsefulPlayAddr) {
                        firstUsefulPlayAddr = v.pull_address;
                    }
                });
            });

            // 记录主线路
            if (streamItem.is_main) {
                this.mainStream = streamItem.stream;
                this.hls_play_addr = firstUsefulPlayAddr;
                this.originMainStream = liveItem;
                this.has_multi_stream_line = sources.length > 1;
                this.live_status = streamItem.live_status;
            }

            return {
                isLive: true,
                image: this.live_img,
                is_main: !!streamItem.is_main,
                title: streamItem.name,
                sources: sources
            };
        }

        // type是1，刷新累计观看人数

    }, {
        key: '_refreshChannelPV',
        value: function _refreshChannelPV() {
            var _this12 = this;

            var pvUrl = config.API_DOMAIN + '/analytics/api/activity/upv?page=/activity/' + this.actHashId + '&time=' + Date.now();
            return new _promise2["default"](function (resolve, reject) {
                _this12.lastUpdateViewNumAt = Date.now();
                Fetcher.Get(pvUrl, function (resp) {
                    var res = JSON.parse(resp);
                    if (res.errcode == 1000) {
                        // 计算显示人数 type 0/1/2 0表示不显示，1显示累计人数，2显示真实人数
                        var multiple = _this12.view_num_multiple <= 0 ? 1 : _this12.view_num_multiple;
                        _this12.view_num = _this12.view_num_basic + res.pv * multiple;
                        _scope.MsgBus.Pub('Room.ViewNumChanged', _this12.view_num);

                        resolve({ view_num: _this12.view_num });
                    } else {
                        reject(res);
                    }
                }, _this12._tokenHeader);
            });
        }

        // type是2，刷新在线人数

    }, {
        key: '_refreshChannelUV',
        value: function _refreshChannelUV() {
            var _this13 = this;

            var uvUrl = config.API_DOMAIN + '/datareport/api/concurrent?project_id=' + this.projectId + '&act_id=' + this.actHashId + '&time=' + Date.now();
            this.lastUpdateViewNumAt = Date.now();
            return new _promise2["default"](function (resolve, reject) {
                Fetcher.Get(uvUrl, function (resp) {
                    var res = JSON.parse(resp);
                    if (res.errcode == 1000) {
                        // 计算显示人数 type 0/1/2 0表示不显示，1显示累计人数，2显示真实人数
                        var multiple = _this13.view_num_multiple <= 0 ? 1 : _this13.view_num_multiple;
                        _this13.view_num = _this13.view_num_basic + res.count * multiple;
                        _scope.MsgBus.Pub('Room.ViewNumChanged', _this13.view_num);

                        resolve({ view_num: _this13.view_num });
                    } else {
                        reject(res);
                    }
                }, _this13._tokenHeader);
            });
        }

        // -------内部接口结束---------


        // （多流）获取流地址列表

    }, {
        key: 'GetStreamList',
        value: function GetStreamList() {
            return this.allStreams;
        }

        //获取浏览量

    }, {
        key: 'RefreshViewNum',
        value: function RefreshViewNum() {
            var _this14 = this;

            // 5s之内不更新
            if (Date.now() - this.lastUpdateViewNumAt < 5 * 1000) {
                return _promise2["default"].resolve({ view_num: this.view_num });
            }

            clearTimeout(this._refreshViewNumTimer);
            // 保持持续更新
            if (this.view_num_type > 0) {
                this._refreshViewNumTimer = setTimeout(function () {
                    _this14.RefreshViewNum();
                }, 60 * 1000);
            }

            // 从接口刷新
            switch (this.view_num_type) {
                // type === 1，刷新累计观看人数
                case 1:
                    return this._refreshChannelPV();
                // type === 2，刷新在线人数
                case 2:
                    return this._refreshChannelUV();
                case 0:
                    return _promise2["default"].resolve({ view_num: 0 });
                default:
                    return _promise2["default"].resolve({ view_num: this.view_num });
            }
        }

        // 获取页面浏览量

    }, {
        key: 'GetViewNum',
        value: function GetViewNum() {
            // 超过30s，即时返回当前数据并触发一次更新
            if (Date.now() - this.lastUpdateViewNumAt >= 30 * 1000) {
                this.RefreshViewNum();
            }
            return this.view_num;
        }
    }, {
        key: 'GetName',
        value: function GetName() {
            return this.name;
        }
    }, {
        key: 'GetStream',
        value: function GetStream() {
            return this.stream;
        }
    }, {
        key: 'GetShareUrl',
        value: function GetShareUrl() {
            return this.share_url;
        }
    }, {
        key: 'GetLiveImage',
        value: function GetLiveImage() {
            return this.live_img;
        }
    }, {
        key: 'GetId',
        value: function GetId() {
            return this.act_id;
        }
    }, {
        key: 'GetLiveStatus',
        value: function GetLiveStatus() {
            return this.live_status;
        }
    }, {
        key: 'GetMenus',
        value: function GetMenus() {
            return this.menus;
        }
    }, {
        key: '_fetchMenuVideo',
        value: function _fetchMenuVideo(id, menus) {
            var _self = this;
            var getVideoUrl = config.API_DOMAIN_V2 + '/v2/micro-act/view/menu/videos?act_id=' + this.actHashId + '&menu_id=' + id;
            Fetcher.Get(getVideoUrl, function (res) {
                res = JSON.parse(res);
                if (res.errcode === 1000) {
                    _self.menus = menus.map(function (item) {
                        if (item.menu_id == id) {
                            var newVideos = res.data ? res.data.videos : [];
                            // 为video列表添加vid字段(api中不暴露)
                            // newVideos.map(v => { v.vid = v.video_id;});
                            item.videos = newVideos;
                        }
                        return item;
                    });
                }
            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, _self._sessionHeader, self._tokenHeader));
        }
    }, {
        key: '_fetchMenus',
        value: function _fetchMenus() {
            var _self = this;
            // 获取自定义菜单
            var getMenuUrl = config.API_DOMAIN_V2 + '/v2/micro-act/view/menus?act_id=' + this.actHashId;
            Fetcher.Get(getMenuUrl, function (res) {
                res = JSON.parse(res);
                if (res.errcode === 1000) {
                    _self.menus = res.menus;
                    res.menus && res.menus.map(function (item) {
                        if (item.type == 3) {
                            _self._fetchMenuVideo(item.menu_id, res.menus);
                        }
                    });
                } else {
                    _self.menus = [];
                }
            }, (0, _extends3["default"])({ 'Content-Type': 'application/json' }, _self._sessionHeader, self._tokenHeader));
        }

        // 广告栏

    }, {
        key: 'GetBanners',
        value: function GetBanners() {
            return this.banners;
        }

        // 获取当前使用的主题

    }, {
        key: 'GetActiveTheme',
        value: function GetActiveTheme() {
            return this.theme;
        }

        // 获取主题配置数组

    }, {
        key: 'GetThemes',
        value: function GetThemes() {
            return this.themes;
        }

        // 获取倒计时

    }, {
        key: 'GetCountdown',
        value: function GetCountdown() {
            if (!this.countdown) {
                return {
                    server_timestamp: this.server_timestamp
                };
            } else {

                return (0, _extends3["default"])({}, this.countdown, { server_timestamp: this.server_timestamp });
            }
        }

        // 返回列表直播当前配置

    }, {
        key: 'GetListLiveConfig',
        value: function GetListLiveConfig() {
            return {
                inUse: this.isListLiving,
                address: this.listLiveAddress
            };
        }

        /**
         * ———————————— 👇预备废弃接口 ————————————
         * 废弃接口需要通知客户更改，暂保持原有返回值，之后根据产品协商预备下线
         */

        /**
         * 获取直播流地址（主流）
         */

    }, {
        key: 'GetPlayAddr',
        value: function GetPlayAddr() {
            // TODO: 后期隐藏返回值
            // eslint-disable-next-line no-console
            // console.warn('GetPlayAddr()接口已废弃，不再返回流地址。如需播放直播流直接在player参数中指定isLive为true即可。');
            return this.hls_play_addr;
        }

        /**
         * 获取流地址
         * @param {string} streamType 流类型
         */

    }, {
        key: 'GetPlayAddrList',
        value: function GetPlayAddrList(stream_id) {
            // TODO: 后期隐藏返回值
            // eslint-disable-next-line no-console
            // console.warn('GetPlayAddrList()接口已废弃，不再返回流地址。如需播放直播流直接在player参数中指定isLive为true即可。');
            if (stream_id) {
                var playlistItem = this.mapStreamToPlaylistItem[stream_id];
                if (playlistItem) {
                    return [playlistItem];
                }
            }
            return [this.mapStreamToPlaylistItem[this.mainStream]];
        }

        /**
         * 是否有多线路多分辨率
         */

    }, {
        key: 'HasMultiStreamLine',
        value: function HasMultiStreamLine() {
            // TODO: 后期隐藏返回值
            // eslint-disable-next-line no-console
            // console.warn('HasMultiStreamLine()接口已废弃，始终返回false。如已指定播放器参数isLive为true，sdk将在加载Player时自动适配加载多分辨率线路配置。');
            return this.has_multi_stream_line;
        }

        /**
         * 获取直播间playlist(默认返回主流，有流id返回对应item)，直接用于播放器
         */

    }, {
        key: 'GetPlayList',
        value: function GetPlayList() {
            // TODO: 后期隐藏返回值
            // eslint-disable-next-line no-console
            // console.warn('GetPlayList()接口已废弃，不再返回各个线路地址。isLive配置为true的情况下，sdk会根据后台配置自动适配选择合适的线路播放。');
            return this.originMainStream;
        }

        /**
         * 获取海外播放地址
         */

    }, {
        key: 'GetOverseaPlayList',
        value: function GetOverseaPlayList() {
            // 海外线路选择已在解析时处理，此处直接返回最终直播地址
            // TODO: 后期隐藏返回值
            // eslint-disable-next-line no-console
            // console.warn('GetOverseaPlayList()接口已废弃，不再返回海外线路地址。isLive配置为true的情况下，sdk会根据后台配置自动适配选择合适的线路播放。');
            return [this.mapStreamToPlaylistItem[this.mainStream]];
        }

        /**
         * 获取回放视频配置
         * 仅对单个回放视频生效，默认返回主流线路
         */

    }, {
        key: 'GetTrailer',
        value: function GetTrailer(stream_id) {
            // TODO: 后期隐藏返回值
            // eslint-disable-next-line no-console
            // console.warn('GetTrailer()接口已废弃，不再返回点播视频地址。如需播放点播直接在player参数中指定isLive为false，同时src传空值（null|undefined|\'\',或不传）即可。');
            var trailerInfo = this.trailer || {};
            var checkedStreamId = stream_id || this.mainStream;

            // 如果传入值和mainStream都没有，不再重新赋值
            if (checkedStreamId) {
                trailerInfo = this.mapStreamToTrailerItems[checkedStreamId] || this.mapStreamToTrailerItems[this.mainStream] || {};
            }

            return (0, _extends3["default"])({}, trailerInfo, {
                m3u8: trailerInfo.m3u8 || '',
                open: !!trailerInfo.open,
                trailer_img: trailerInfo.trailer_img || '',
                draggable: trailerInfo.draggable || false,
                triple_speed: trailerInfo.triple_speed || false,
                resolution: trailerInfo.resolution || ''
            });
        }

        // 获取单个视频信息

    }, {
        key: 'GetVideoInfo',
        value: function GetVideoInfo(video_id) {
            // TODO: 后期隐藏返回值
            // eslint-disable-next-line no-console
            // console.warn('GetVideoInfo()接口即将被废弃，下个版本迭代中将不再返回此video_id下的视频信息。如需播放直接在player参数中指定isLive为false，并传入video_id即可');
            return this._getVideoInfo(video_id);
        }

        /**
         * 获取直播间地址列表 暂时未使用
         */

    }, {
        key: 'GetRoomAddrList',
        value: function GetRoomAddrList() {
            return {};
        }
    }]);
    return Room;
}();



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Room.js
 ** module id = 129
 ** module chunks = 1
 **/